import { Pressable, Text, View } from 'react-native'
import { Link } from 'expo-router'
import { colors } from '@/src/theme'
import { label1, label2 } from '@/src/theme/typography'
import { useTranslation } from 'react-i18next'

export interface VoiceAssessmentSectionHeaderProps {
  /** When false, History is shown muted and not navigable (e.g. no assessments yet). */
  historyEnabled?: boolean
}

export function VoiceAssessmentSectionHeader({
  historyEnabled = true,
}: VoiceAssessmentSectionHeaderProps) {
  const { t } = useTranslation(['statistics'])

  return (
    <View className="flex-row items-center justify-between">
      <Text style={[label1, { color: colors.textHeader }]}>
        {t('statistics:voice_assessment_section_title')}
      </Text>
      {historyEnabled ? (
        <Link href="/voice-assessment-history" asChild>
          <Pressable hitSlop={8} className="active:opacity-70">
            <Text style={[label2, { color: colors.primary }]}>
              {t('statistics:voice_assessment_history_link')}
            </Text>
          </Pressable>
        </Link>
      ) : (
        <Text
          accessibilityState={{ disabled: true }}
          style={[label2, { color: colors.textMuted }]}
        >
          {t('statistics:voice_assessment_history_link')}
        </Text>
      )}
    </View>
  )
}
